import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { NgxSpinnerModule } from 'ngx-spinner';
import { DataTablesModule } from 'angular-datatables';
import { OtherKpMainTableComponent } from './component/other-kp-main/other-kp-main-table.component';
import { BusOtherKpFilterService } from './services/bus-other-kp-filter.service';
import { OtherKpPageRoutingModule } from './other-kp-page-routing.module';
import { OtherKpDistributorsComponent } from './component/other-kp-main/other-kp-main-modal-distributor/other-kp-main-modal-distributor.component';
import { OtherKpKamsComponent } from './component/other-kp-main/other-kp-main-modal-kam/other-kp-main-modal-kam.component';
import { OtherKpCustomersComponent } from './component/other-kp-main/other-kp-main-modal-customer/other-kp-main-modal-customer.component';
import { OtherKpRegionsComponent } from './component/other-kp-main/other-kp-main-modal-region/other-kp-main-modal-region.component';
import { OtherKpDetailService } from './services/other-kp-detail.service';
import { OtherKpMainModalDetailComponent } from './component/other-kp-detail/other-kp-modal-detail.component';
import { OtherKpNomenclaturesComponent } from './component/other-kp-main/other-kp-main-modal-nomenclature/other-kp-main-modal-nomenclature.component';
import { ModalOtherKpHistoryChangeComponent } from './component/other-kp-detail/modal-history-change/modal-history-change.component';
import { ModalOtherKpMailSenderComponent } from './component/other-kp-detail/modal-mail-sender/modal-mail-sender.component';
import { ModalOtherKpSendAdjustmentComponent } from './component/other-kp-detail/modal-other-kp-send-adjustment/modal-other-kp-send-adjustment.component';

@NgModule({
  providers: [
    BusOtherKpFilterService,
    OtherKpDetailService
  ],
  imports: [
    OtherKpPageRoutingModule,
    CommonModule,
    DataTablesModule,
    FormsModule,
    TableModule,
    NgxSpinnerModule,
  ],
  declarations: [
    OtherKpMainTableComponent,
    OtherKpDistributorsComponent,
    OtherKpKamsComponent,
    OtherKpRegionsComponent,
    OtherKpCustomersComponent,
    OtherKpMainModalDetailComponent,
    OtherKpNomenclaturesComponent,
    ModalOtherKpHistoryChangeComponent,
    ModalOtherKpMailSenderComponent,
    ModalOtherKpSendAdjustmentComponent
  ]
})
export class OtherKpPageModule { }



// WEBPACK FOOTER //
// ./src/app/modules/other-kp/other-kp-page.module.ts